import { t } from 'i18next'
import React from 'react'
import { useEffect } from 'react'
import { useState } from 'react'
import { Button } from 'react-bootstrap'
import { MdLibraryAdd } from 'react-icons/md'
import AssetSelectModal from '../../AssetSelect/AssetSelectModal'

const AssetSelect = ({ setFormData, name, disabled, singleSelection }) => {
  const [showAddAssetsModal, setShowAddAssetsModal] = useState(false)
  const [selectedAssets, setSelectedAssets] = useState([])
  useEffect(() => {
    setFormData(prev => {
      const newValues = { ...prev }
      if (!selectedAssets.length) {
        delete newValues[name]
      } else {
        newValues[name] = selectedAssets.map(asset => asset.id)
      }
      return newValues
    })
  }, [setFormData, selectedAssets, name])
  return (
    <>
      <Button className="w-100 mb-3" onClick={() => setShowAddAssetsModal(true)} disabled = {disabled}><MdLibraryAdd className="me-3" />{singleSelection ? t('asset_select') : t('inventory:addAsset')} {(selectedAssets.length && !singleSelection) ? `(${selectedAssets.length})` : null} </Button>
      {showAddAssetsModal
        ? <AssetSelectModal
          selectedAssets={selectedAssets}
          setSelectedAssets={setSelectedAssets}
          setShowAddAssetsModal={setShowAddAssetsModal}
          showAddAssetsModal={showAddAssetsModal}
          handleSave={() => setShowAddAssetsModal(false)}
          singleSelection={singleSelection}
        />
        : null}
    </>

  )
}

export default AssetSelect